<template>

<div class="page">

	<div class="page-body">

		<slot></slot>

	</div>

</div>

</template>

<script>

export default {

	data: function() {

		return {

			is: {
				expanded: false
			}

		}

	},

	methods: {

		onToggleClick: function() {

			this.is.expanded = !this.is.expanded

		}

	}

}

</script>

<style scoped>

.page {
	width: 100%;
	height: 100vh;
	display: flex;
	overflow-y: scroll;
	flex-direction: column;
}

.page-head {
	flex-shrink: 0;
	background-color: #343434;
	height: 72px;
}

.is-mobile .page-head {
	height: 54px;
}

.page-head-inner {
	display: flex;
	justify-content: flex-end;
	height: 72px;
	padding: 0px 20px;
	align-items: center;
}

.is-mobile .page-head-inner {
	justify-content: flex-start;
	height: 54px;
	padding: 0px 0px;
}

.page-head-inner >>> img {
	height: 45px;
	width: auto;
	margin-right: 10px;
	margin-left: 0px;
}

.page-head-toggle {
	width: 54px;
	height: 54px;
	position: absolute;
	right: 0px;
	top: 0px;
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-image: url(~@/assets/head.toggle.svg);
	cursor: pointer;
}

.page-menu {
	position: absolute;
	top: 72px;
	z-index: 2;
	width: 100%;
}

.is-mobile .page-menu {
	top: 54px;
	background-color: #343434;
	left: 0px;
	width: 100%;
	bottom: 0px;
	z-index: 1000;
	position: fixed;
}

.page-menu-inner {
	display: flex;
	justify-content: flex-end;
	height: 72px;
	align-items: center;
}

.is-mobile .page-menu-inner {
	height: auto;
	flex-direction: column;
	justify-content: flex-start;
	padding-top: 20px;
}

.page-menu-item {
	height: 72px;
	padding: 0px 16px;
	line-height: 72px;
	color: #343434;
	letter-spacing: 1px;
	font-size: 10px;
	font-weight: 300;
	text-transform: uppercase;
}

.is-mobile .page-menu-item {
	color: #fff;
	text-align: center;
	height: 40px;
	line-height: 40px;
	font-size: 14px;
}

.is-desktop .page-menu-item:hover {
	text-decoration: underline;
}

.page-logo {
	position: absolute;
	z-index: 2;
	width: 261px;
	height: 65px;
	background-image: url(~@/assets/logo.svg);
	background-size: contain;
	background-repeat: no-repeat;
	top: 139px;
}

.is-desktop .page-logo {
	left: 50%;
	margin-left: -580px;
}

.is-tablet .page-logo {
	left: 20px;
}

.is-mobile .page-logo {
	left: 50%;
	margin-left: -100px;
	top: 210px;
	width: 200px;
	height: 48px;
}

.page-logo span {
	visibility: hidden;
}

.page-body {
	flex-grow: 1;
	z-index: 1;
}

.page-foot {
	flex-shrink: 0;
	background-color: #343434;
	padding: 48px 0px;
	text-align: center;
}

.page-foot-inner {
	padding: 0px 20px;
}

.page-foot >>> p {
	font-size: 12px;
	color: #fff;
	line-height: 20px;
	font-weight: 400;
	margin-bottom: 20px;
}

.page-foot >>> *:last-child {
	margin-bottom: 0px;
}

</style>